import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, ApiError } from "@/lib/api";
import { BrandLogo } from "@/components/Logo";
import { Spinner } from "@/components/ui";
import { TextInput } from "@/components/fields";

export function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [f, setF] = useState({ password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (f.password !== f.confirm) { setErr("Passwords do not match"); return; }
    setBusy(true); setErr("");
    try {
      await api.post("/auth/reset-password", { token, newPassword: f.password });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (e) {
      setErr(e instanceof ApiError ? e.message : "Reset failed");
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-dvh items-center justify-center bg-canvas p-4">
      <div className="w-full max-w-md">
        <div className="mb-6 flex flex-col items-center">
          <BrandLogo height={60} />
          <h2 className="mt-3 font-serif text-xl font-bold">Choose a new password</h2>
        </div>
        <div className="card p-6">
          {!token ? (
            <p className="text-sm text-ink-soft">This page needs a valid reset link. <Link to="/login" className="text-brand-600 hover:underline">Back to sign in</Link></p>
          ) : done ? (
            <p className="text-sm text-st-ontrack">Password updated. Redirecting to sign in…</p>
          ) : (
            <form onSubmit={submit} className="space-y-3.5">
              {err && <div className="rounded-lg bg-st-delayed/10 px-3 py-2 text-sm text-st-delayed">{err}</div>}
              <label className="block">
                <span className="label">New password (min 10 chars)</span>
                <TextInput type="password" minLength={10} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required />
              </label>
              <label className="block">
                <span className="label">Confirm password</span>
                <TextInput type="password" minLength={10} value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} required />
              </label>
              <button className="btn-primary w-full" disabled={busy}>{busy ? <Spinner /> : "Update password"}</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
